import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Videocam } from '@material-ui/icons';
import cx from 'classnames';
import { motion, AnimatePresence } from 'framer-motion';
import { NODES } from '../../../constants';
import { EventEmitter } from '../../../utils';
import PopupWrapper from '../../PopupWrapper';

class Video extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      embedText: '',
      imageLoading: false,
    };

    this.togglePopup = this.togglePopup.bind(this);
    this.insertEmbed = this.insertEmbed.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  componentDidMount() {
    EventEmitter.listen('open-popup--image', () => {
      this.togglePopup();
    });
  }

  togglePopup() {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }));
  }

  insertEmbed(event) {
    event.preventDefault();

    this.props.editor.insertBlock({
      type: NODES.VIDEO,
      data: { embedText: this.state.embedText },
    });
    this.togglePopup();
    this.setState({ embedText: '' });
  }

  onChangeHandler(event) {
    this.setState({ embedText: event.target.value });
  }

  render() {
    const disableSubmitButton = !this.state.embedText.trim();
    return (
      <PopupWrapper
        isOpen={this.state.showPopup}
        togglePopup={this.togglePopup}>
        <span className="icon__wrapper icon__wrapper--image">
          <button
            title="Image"
            className={cx('icon__button', {
              active: this.state.showPopup,
            })}
            onClick={this.togglePopup}>
            <Videocam />
          </button>
          <AnimatePresence>
            {this.state.showPopup && (
              <motion.div
                initial={{ opacity: 0, y: '80%' }}
                animate={{ opacity: 1, y: '100%' }}
                exit={{ opacity: 0, y: '80%' }}
                transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: 0.3 }}
                className="icon__popup icon__popup--image">
                <textarea
                  className="normal-border-sm w-64 rounded-sm mb-5 p-2"
                  id="embedText"
                  name="embedText"
                  placeholder="embed text"
                  onChange={this.onChangeHandler}
                  value={this.state.embedText}
                />
                <button
                  onClick={this.insertEmbed}
                  className={cx(
                    'cursor-pointer font-bold normal-button p-1 rounded w-full',
                    { disable: disableSubmitButton }
                  )}>
                  Insert Embed
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </span>
      </PopupWrapper>
    );
  }
}

export default  Video;
